import clsx from 'clsx'
import { RiChat3Line, RiEyeLine } from '@remixicon/react'
import { convertNumberToCompactFormat } from 'src/utils/convertNumberToCompactFormat'
import i18n from 'src/i18n'
import { PostInteractionCountersProps } from './postInteractionCounters.types'
import { Wrapper } from './postInteractionCounters.styles'

const PostInteractionCounters = ({
  comments = 0,
  views = 0,
  enabledComments,
  className,
  onClickCommentCounter
}: PostInteractionCountersProps) => {
  const viewsLabel =
    views === 1 ? i18n.t('feed.previews.preview_one') : i18n.t('feed.previews.preview_other')

  const commentsLabel =
    comments === 1 ? i18n.t('feed.comments.comment_one') : i18n.t('feed.comments.comment_other')

  return (
    <Wrapper
      className={clsx(
        className,
        '_d-flex _align-items-center _justify-content-center _font-14 _text-gray-600'
      )}
    >
      <span className="_d-flex _align-items-center _justify-content-center _px-2 _py-1">
        <RiEyeLine size={14} className="_mr-1" />
        {convertNumberToCompactFormat(views)} {viewsLabel}
      </span>

      {enabledComments && (
        <span
          className={clsx('_d-flex _align-items-center _justify-content-center _px-2 _py-1', {
            '_cursor-pointer': onClickCommentCounter
          })}
          onClick={onClickCommentCounter}
        >
          <RiChat3Line size={14} className="_mr-1" />
          {convertNumberToCompactFormat(comments)} {commentsLabel}
        </span>
      )}
    </Wrapper>
  )
}

export default PostInteractionCounters
